import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableColumnsType } from 'antd';
import { IEvaluationItemBody, IEvaluationItem, IEvaluationItemCreate } from '../../../models/evaluationItem.model';
import Button from '../../Button';
import useUtil from '../../../hooks/useUtil';
import EvaluationItemModal from './modals/EvaluationItemModal';

interface IProps {
  data?: IEvaluationItem[];
  onCreate: (body: IEvaluationItemCreate) => void;
  onUpdate: (evaluationItemCode: number, body: IEvaluationItemBody) => void;
  onRowClick: (evaluationItemCode: number) => void;
  evaluationItemParentCode: number|undefined;
}

const Level1Content: FC<IProps> = ({
  data,
  onUpdate,
  onCreate,
  onRowClick,
  evaluationItemParentCode,
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();

  const [evaluationItemVisible, setEvaluationItemVisible] = useState(false);
  const [evaluationItem, setEvaluationItem] = useState<IEvaluationItem>();

  const columns: TableColumnsType<IEvaluationItem> = [
    {
      title: t('program.criteria.column1'),
      dataIndex: 'evaluationItemName',
    },
    {
      title: t('program.criteria.1'),
      dataIndex: 'evaluationBrnCode',
      render: value => getCommonCodeLabel('GR0007', value)
    },
    {
      title: t('program.criteria.column4'),
      dataIndex: 'useYN',
    },
    {
      title: '',
      dataIndex: 'evaluationItemCode',
      render: (_, record) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small pink-line"
            text={t('common.button.edit')}
            onClick={e => {
              e.stopPropagation();
              setEvaluationItem(record);
              setEvaluationItemVisible(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            text={t('program.award.button2')}
            onClick={() => {
              setEvaluationItem(undefined);
              setEvaluationItemVisible(true);
            }}
          />
        </div>
      </div>
      <Table
        className='comm-table__area'
        onRow={({ evaluationItemCode }) => {
          return {
            onClick: (e) => {
              console.log('onRowEvent: ', e.target);
              onRowClick(evaluationItemCode);
            },
          };
        }}
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey="evaluationItemCode"
        rowClassName={record => record.evaluationItemCode === evaluationItemParentCode ? 'chosen' : 'pointer'}
      />

      {evaluationItemVisible && (
        <EvaluationItemModal
          visible={evaluationItemVisible}
          setVisible={setEvaluationItemVisible}
          evaluationItem={evaluationItem}
          onCreate={onCreate}
          onUpdate={onUpdate}
        />
      )}
    </>
  );
};

export default Level1Content;